import * as CONSTANTS from '@/store/constants.js'

const state = {
  errors: []
}

const getters = {
  errors: (state) => state.errors,
}

const actions = {
  loadErrors: ({commit, dispatch, state}) => {
    vm.$db.getErrors().then(errors => {
      commit('error/errors', errors, {root: true})
    })
  },
  logError: ({commit, dispatch, state}, error) => {
    if( ! error.silent) vm.$toasted.show(err)
    commit('error/error', error, {root: true})
  }
}

const mutations = {
  errors: (state, errors) => {
    state.errors = errors
  },
  error: (state, error) => { 
    state.errors.push(error)
    vm.$db.addError(error)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
